import { Button } from '../../../cdl/Button/Button';
import { Modal } from '../../../cdl/Modal/Modal';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

interface RemoveAllProductsModalProps {
    isOpen: boolean;
    onSubmit: () => void;
    onDismiss: () => void;
    isSubmitting?: boolean;
}

export const RemoveAllProductsModal = ({
    isOpen,
    onSubmit,
    onDismiss,
    isSubmitting = false,
}: RemoveAllProductsModalProps) => {
    return (
        <Modal isOpen={isOpen} scrollable={false} onDismiss={onDismiss} dismissible={false}>
            <Box display="grid" gap={16} padding={24}>
                <Text variant="title">{translate('vessel.products.deleteAllConfirm.headline')}</Text>

                <Text variant="small" color="foreground.muted">
                    {translate('vessel.products.deleteAllConfirm.text')}
                </Text>

                <Box display="flex" justifyContent="end" gap={8}>
                    <Button type="button" onClick={onDismiss}>
                        {translate('btn.goBack')}
                    </Button>
                    <Button emphasis="high" type="button" destructive onClick={onSubmit} isLoading={isSubmitting}>
                        {translate('vessel.products.deleteAllConfirm.button')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};
